import { Box } from "@mui/material";
import { DatePicker, Input, SectionDivider } from "../../";
import { RequestsTable } from "./requests-table";
import { useStyles } from "./style";
import { useTranslation } from "react-i18next";

export const Requests = () => {
  const { t } = useTranslation();

  const classes = useStyles();

  const requestsTableData = [
    {
      wait: "12-10-2024",
      request: "Request",
      state: "Done",
    },
    {
      wait: "5 hours",
      request: "Upgrade to paid subscription",
      state: "Pending",
    },
  ];

  return (
    <Box className={classes.container}>
      <Box className={classes.rowWrapper}>
        <Box className={classes.label}>{t("accountDetails.account")}</Box>
        <Box className={classes.value}>Bob Smith</Box>
      </Box>

      <SectionDivider label={t("accountDetails.pendingRequests")} />

      <RequestsTable data={requestsTableData} />

      <Box className={classes.updateToSubscriptionContainer}>
        <Box className={classes.upgradeSubscriptionTitle}>
          {t("accountDetails.upgradeToPaidSubscription")}
        </Box>
        <Box className={classes.subInfoGeneralContainer}>
          <Box className={classes.subInfoWrapper}>
            <Box className={classes.subInfoLabel}>
              {t("accountDetails.created")}
            </Box>
            <Box className={classes.subInfoValue}>10-15-24</Box>
          </Box>

          <Box className={classes.subInfoWrapper}>
            <Box className={classes.subInfoLabel}>
              {t("accountDetails.status")}
            </Box>
            <Box className={classes.subInfoValue}>Done</Box>
          </Box>

          <Box className={classes.subInfoWrapper}>
            <Box className={classes.subInfoLabel}>
              {t("accountDetails.closed")}
            </Box>
            <Box className={classes.subInfoValue}>10-15-24</Box>
          </Box>
        </Box>

        <SectionDivider label={t("accountDetails.transaction")} />

        <Box className={classes.rowWrapper}>
          <Box sx={{ width: "50%" }}>
            <Input label={t("accountDetails.invoice")} required />
          </Box>

          <Box sx={{ width: "50%" }}>
            <DatePicker
              label={t("accountDetails.start")}
              required
              onChangeDate={() => {
                console.log("clicked on date picker");
              }}
            />
          </Box>
        </Box>

        <Input label={t("accountDetails.notes")} givenHeight="83px" />

        <Box
          className={classes.rowWrapper}
          sx={{ marginTop: "8px", marginBottom: "8px" }}
        >
          <Box className={classes.label}>{t("accountDetails.updated")}</Box>
          <Box className={classes.value}>10-15-2024</Box>
        </Box>
      </Box>
    </Box>
  );
};
